module.exports = __webpack_public_path__ + "staticcomp/img/top.fb4b666.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/1/top.jpg
// module id = 7heq
// module chunks = 39